<template>
  <!-- locally installed, namespaced sticky -->
  <cards class="menu-card">
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <delivery-pickup-menu
          v-if="selectedLocation && selectedLocation.id"
          :small="true"
          :cart="cart"
          :isHome="false"
          :showTable="showTable"
        ></delivery-pickup-menu>
      </li>
      <li class="list-group-item">
        <div>
          <p class="text-center text-cart">{{$t('text.swipe_or_tap')}}</p>
          <p class="text-center text-cart">{{$t('text.your_order')}} :</p>
          <div v-if="!isCartEmpty" class="items-container">
            <swipe-list :items="cart.order" item-key="id">
              <template v-slot="{ item, index }">
                <div
                  ref="content"
                  class="card-content clickable"
                  @click="onItemEdit(item, index)"
                >
                  <div class="checkout-menu-Item">
                    <div class="remove-item">
                      <i
                        @click.stop="onItemDelete(index)"
                        class="k-icon-minus-circled"
                      ></i>
                    </div>
                    <div class="count-item">
                      <span>{{ item.quantity }}x</span>
                    </div>
                    <div class="description-item">
                      <p>{{ item.name }}</p>
                    </div>
                    <div class="total-price-item">
                      <span>{{ getItemPrice(item) | currency(currentCurrency) }}</span>
                    </div>
                    <div class="options-item">
                      <div v-if="item.hasOptions">
                        <div
                          v-for="(option, index) in item.options"
                          :key="index"
                        >
                          <div
                            v-if="
                              option.type === 'RADIO' ||
                                option.type === 'SELECT'
                            "
                          >
                            <div
                              class="options-item-grid"
                              v-for="(value, index) in option.values"
                              :key="index"
                            >
                              <div
                                v-if="value && value.id == option.selected"
                                class="option-name"
                              >
                                ++ {{ value.name }}
                              </div>
                              <div
                                v-if="value && value.id == option.selected"
                                class="option-price"
                              >
                                {{ value.price | currency(currentCurrency) }}
                              </div>
                            </div>
                          </div>
                          <div v-if="option.type === 'CHECKBOX'">
                            <div
                              class="options-item-grid"
                              v-for="(idValue, index) in option.selected"
                              :key="index"
                            >
                              <div v-if="idValue" class="option-name">
                                ++
                                {{
                                  helpers.getValueName(option.values, idValue)
                                }}
                              </div>
                              <div v-if="idValue" class="option-price">
                                {{
                                  helpers.getValuePrice(option.values, idValue)
                                    | currency(currentCurrency)
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="options-comment" v-if="item.comment">
                      [{{ item.comment }}]
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:right="{ item, index }">
                <div
                  class="swipeout-action red"
                  title="remove"
                  @click="onItemDelete(index,item)"
                >
                  <i class="fa fa-trash"></i>
                </div>
              </template>
            </swipe-list>
          </div>
          <div v-else class="text-center">
            <i class="k-icon-basket-2 icon-style"></i>
            <p class="text-cart">
              {{$t('empty.cart')}}
            </p>
          </div>
        </div>
      </li>
      <li v-if="user" class="list-group-item">
        <div class="text-center ml-auto mr-auto">
          <fg-input
            :disabled="isCartEmpty"
            :placeholder="$t('input.placeholder.enter_coupon')"
            v-model="cart.coupon"
          ></fg-input>
          <div class="send-button">
            <n-button
              :style="myTheme.customizeButton"
              :disabled="isCartEmpty || !cart.coupon"
              type="primary"
              @click="onSubmitCoupon(false, true)"
              round
              wide
              >{{ $t("button.submit") }}</n-button>
          </div>
        </div>
      </li>
      <li v-if="!user" class="list-group-item text-center">
        {{$t('message.redeem_coupon_codes')}}
        <n-button
          class="nav-link btn-neutral button-center"
          :style="myTheme.registrationButtons"
          @click="goToLogin()"
        >
          <i class="now-ui-icons k-icon-login"></i>
          {{$t('button.login')}}
        </n-button>
      </li>
      <li class="list-group-item checkout-total">
        <div class="checkout-total-grid">
          <div class="title-column">{{$t("text.sub_total")}}</div>
          <div class="count-column">{{ cart.total | currency(currentCurrency) }}</div>
        </div>
      </li>
      <li class="list-group-item checkout-total">
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t('text.service_charges') }}</div>
          <div class="count-column">
            {{
              cart.service_charge | currency(currentCurrency)
            }}
          </div>
        </div>
      </li>
      <li class="list-group-item checkout-total" v-if='cart.bag_charge && cart.bag_charge != "0.00"'>
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t('text.bag_charge') }}</div>
          <div class="count-column">
            {{
              cart.bag_charge | currency(currentCurrency)
            }}
          </div>
        </div>
      </li>
      <li class="list-group-item checkout-total" v-if="cart.coupon_result">
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t('text.coupon_discount') }}</div>
          <div class="count-column">
            <span
              >- {{ cart.coupon_result.discountAmount | currency(currentCurrency) }}</span
            >
          </div>
        </div>
      </li>
      <li
        class="list-group-item checkout-total"
        v-if="cart.orderType === enumHelper.orderType.Delivery"
      >
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t('text.delivery_fee') }}</div>
          <div class="count-column">
            {{ cart.delivery_fee | currency(currentCurrency) }}
          </div>
          <div>
            <p style=" font-size: 0.7em" class="recalculated">
              {{ $t('text.recalculate_in_checkout') }}
            </p>
          </div>
        </div>
      </li>

      <li class="list-group-item checkout-total">
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t('text.order_total') }}</div>
          <div class="count-column">{{ orderTotal | currency(currentCurrency) }}</div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="send-button">
          <n-button
            :style="myTheme.customizeButton"
            type="primary"
            :disabled="!isCheckoutEnabled"
            @click="onClick"
            round
            block
            >{{ $t("button.checkout") }}</n-button
          >
        </div>
      </li>
    </ul>
  </cards>
</template>
<script>
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { Cards, Button, FormGroupInput, RadioButton } from "@/components";
import { helpers, cartManager, enumHelper } from "@/utilities";
import { mapState } from "vuex";
import { SwipeList } from "vue-swipe-actions";
import router from "@/router";
import { DeliveryPickupMenu } from "@/layout";
import couponMixin from "../../mixins/couponMixin";
export default {
  name: "cart-details",
  mixins:[couponMixin],
  components: {
    DeliveryPickupMenu,
    Cards,
    [RadioButton.name]: RadioButton,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    SwipeList,
  },
  props: {
    action: String,
    cart: Object,
    hide: Boolean,
    showTable: Boolean,
  },
  data() {
    return {
      enumHelper: enumHelper,
      helpers,
      enabled: true,
      isMounted: false,
      coupon: "",
      deliverFeeStatus: null,
    };
  },
  methods: {
    onItemDelete(_index) {
      this.$root.$emit("REMOVE_ITEM", _index);
    },
    onItemEdit(_item, _index) {
      this.$root.$emit("PUSH_ITEM", {
        item: _item,
        openModal: true,
        editMode: true,
        index: _index,
      });
    },
    getItemPrice(_item) {
      return helpers.getItemTotal(_item, this.cart.orderType);
    },
    onClick() {
      this.refreshLocationData()
        .then(() => {
          if (
            helpers.controlAvailibilityBeforeCheckout(
              this.locationStatus,
              cartManager.getCart()
            )
          ) {
            let message = this.$t("message.location_temporary_closed")
            if (this.selectedLocation.openingHours.suspended) {
              message = this.$t('message.location_temporary_paused_to', {paused_to : this.selectedLocation.paused_to })
            }

            helpers
              .showErrorMessageAlert(message, null, "red", "OK")
              .then(() => {
                this.goToHome();
              });
          } else {
                //---- if the order is a Re-Order =>  check if the menuItem required options are selected
                helpers
                  .checkOrderItemsAvailibility(this.cart.order, this.$moment(), this.locationMenuItems)
                  .then((itemsNotAvailableFor) => {

                    if (
                      itemsNotAvailableFor.today.length ||
                      itemsNotAvailableFor.now.length
                    ) {
                      let message = "";
                      if (itemsNotAvailableFor.today.length) {
                        message =
                          `${this.$t("message.items_not_available_for_today")} : <br> <ul class='order-items'>`;
                        itemsNotAvailableFor.today.forEach((item) => {
                          message += `<li>${item.name}</li>`;
                        });
                        message += "</ul>";
                      }
                      if (itemsNotAvailableFor.now.length) {
                        message +=
                          `${this.$t("message.items_not_available_for_now")} : <br> <ul class='order-items'>`;
                        itemsNotAvailableFor.now.forEach((item) => {
                          message += `<li>${item.name}</li>`;
                        });
                        message += "</ul>";
                      }

                      message += `<p class='message'>${this.$t("message.items_automaticaly_removed")}</p>`;

                      helpers.showErrorMessageAlert(
                        message,
                        "k-icon-preptime",
                        this.staticColor.orange
                      );

                      //--- remove the outdated items
                      let itemsId = itemsNotAvailableFor.today
                        .concat(itemsNotAvailableFor.now)
                        .map((x) => x.id);
                      this.$root.$emit("REMOVE_ITEMS", itemsId);
                    } else {
                      helpers.checkRequiredMenuItemOptions(this.cart)
                        .then(() => {
                          //--- verify the coupon if any is provided | coupon is only availabled for logged users
                          if (this.user && this.cart.coupon) {
                            this.onSubmitCoupon(false, false).then((result) => {
                              if (result) {
                                this.continueWithCheckout();
                              }
                            });
                          } else {
                            this.continueWithCheckout();
                          }
                        })
                        .catch((response) => {
                          //console.log(ex)
                          helpers.showErrorMessageAlert(
                            response.map((m) => m + "</br>").join(),
                            null,
                            "red",
                            this.$t("button.ok")
                          );
                        });
                    }
                  })
                  .catch((e) => {
                    this.captureException(e)
                  });
          }
        })
        .catch((e) => {
          this.captureException(e)
          helpers.showErrorMessageAlert(
            this.$t("generic_error.refresh_location_data"),
            null,
            "red",
            "OK"
          );
        });
    },
    continueWithCheckout() {
      if (this.cart.orderType != enumHelper.orderType.Delivery)
        router.push({ name: "checkout" });
      else {
        //--- if delivery is selected => check if the cart total price is greater then delivery minimum in the available delivery areas
        try {
          let min_total_price = helpers.getMinimumDeliveryPrice(
            this.selectedLocation.delivery_condition
          );

          if (this.cart.total < min_total_price) {
            let message = this.$t("message.min_delivery_price", {color:this.staticColor.red , min_total_price : this.$options.filters.currency(min_total_price) })
            let options = {
              html: true,
              animation: "fade",
              type: "basic",
              backdropClose: false,
              customClass: "confirm",
            };
            this.$dialog.alert(message, options).then(function() {
              return;
            });
          } else {
            router.push({ name: "checkout" });
          }
        } catch (e) {
          this.captureException(e)
          helpers.showErrorMessageAlert(this.$t("generic_error.check_deliver_fees"),
            null,
            "red",
            this.$t("button.ok")
          );
        }
      }
    },
    onAddMoreItems() {
      router.push("/menu");
    },
    addEventListener() {
      this.$root.$off("PUSH_COUPON");
      this.$root.$on("PUSH_COUPON", (code) => {
        this.cart.coupon = code;
        this.onSubmitCoupon(false, true);
      });
    },
    goToLogin() {
      router.push({name:"login",query:{redirect:'/menu'}});
    },
    goToHome() {
      router.push("/");
    },
  },
  computed: {
    locationStatus: function() {
      return helpers.canMakeOrder(this.selectedLocation, this.isMounted);
    },
    isCartEmpty() {
      return !this.cart || !this.cart.order || !this.cart.order.length;
    },
    isOrderable() {
      const { can_make_order } = helpers.canMakeOrder(this.selectedLocation);
      return can_make_order;
    },
    isCheckoutEnabled() {
      return !this.isCartEmpty; //|| !this.isOrderable;
    },
    ...mapState({
      orderTotal: (state) => state.orderTotal,
      user: (state) => state.auth.user,
    }),
  },
  mounted() {
    this.addEventListener();
    this.isMounted = true;
  },
};
</script>
<style>
.confirm .order-items {
  text-align: left;
  font-size: 1.1em;
}
.confirm p.message {
  font-size: 1em;
  font-weight: bolder;
  line-height: 1.4em;
}
.confirm p i {
  font-size: 5em;
}
</style>
